/**
 * Checks if the given search text is included in any of the provided string values.
 *
 * Each value in the `values` array is sanitized by converting to lowercase and trimming whitespace.
 * The function returns `true` if the `searchText` is found in any of the sanitized values; otherwise, it returns `false`.
 *
 * @param values - An array of strings to be searched.
 * @param searchText - The text to search for within the values.
 * @returns `true` if `searchText` is found in any value; otherwise, `false`.
 */
export function isTextPresentInValues(searchText: string, values: string[]): boolean {
  if (!searchText) {
    return true;
  }
  searchText = searchText.toLowerCase().trim();
  const sanitizedValues = values?.map((v) => v?.toLowerCase().trim() ?? '');
  return sanitizedValues?.some((v) => v.includes(searchText));
}
